<template>
  <div class="hello">
    <div class="case">
      <!-- 头部 -->
      <div class="top">
        <div class="ti-blck"></div>
        <div class="title">Registered to attend DWC and Shenzhen International UAV Expo 2022！</div>
        <p class="introduce">
          This form should take no more than 5 mins to fill in. Thank you for your interest for DWC, we look forward to seeing you in June. Last but not least, should you have questions in filling this form, please don't hesitate to contact:
          <a href="mailto:int@wuavf.com">int@wuavf.com</a>
        </p>
        <p class="must">*Required</p>
      </div>
      <!-- 尾部 -->
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="0px"
        class="demo-ruleForm"
      >
        <div class="tail">
          <el-form-item prop="name">
            <label>
              Company Name
              <span class="sign">*</span>
            </label>
            <el-input v-model="ruleForm.name" type="text" placeholder="Your answer"></el-input>
          </el-form-item>
        </div>
        <div class="tail">
          <el-form-item prop="Nationality">
            <label>
              Country
              <span class="sign">*</span>
            </label>
            <el-input v-model="ruleForm.Nationality" placeholder="Your answer"></el-input>
          </el-form-item>
        </div>
        <div class="tail">
          <!-- prop="c_logo" -->
          <el-form-item  class="inpdisp">
            <label>
              Company Logo
              <span class="sign"></span>
            </label>
            <el-upload
              class="upload-demo"
              action="http://en.droneworldcongress.com/form/index/uploads/index.html"
              :on-change="handleChange"
              :on-success="logo_success"
              accept=".jpg, .jpeg, .png"
              :before-upload="logo_before"
            >
              <el-button size="small" type="primary">Click on the upload</el-button>
              <div slot="tip" class="el-upload__tip">Only JPG/PNG files can be uploaded，</div>
            </el-upload>
            <el-input v-model="ruleForm.c_logo" placeholder="您的回答"></el-input>
          </el-form-item>
        </div>
        <div class="tail">
          <el-form-item prop="phone">
            <label>
              Company Contact Number
              <span class="sign">*</span>
            </label>
            <el-input v-model="ruleForm.phone" placeholder="Your answer"></el-input>
          </el-form-item>
        </div>
        <div class="tail">
          <!-- prop="Company" -->
          <el-form-item >
            <label>
              Company Introduction (approx. 300 words)
              <span class="sign"></span>
            </label>
            <el-input v-model="ruleForm.Company" placeholder="Your answer"></el-input>
          </el-form-item>
        </div>
        <div class="tail">
          <el-form-item prop="position">
            <label>
              Name of Company Representative (and title)
              <span class="sign">*</span>
            </label>
            <el-input v-model="ruleForm.position" placeholder="Your answer"></el-input>
          </el-form-item>
        </div>
        <div class="tail">
          <el-form-item prop="com_phone">
            <label>
              Contact Number of Company Representative
              <span class="sign">*</span>
            </label>
            <el-input v-model="ruleForm.com_phone" placeholder="Your answer"></el-input>
          </el-form-item>
        </div>
        <div class="tail">
          <div class="cause">
            Please let us know which category meet your company's focus
            <span class="sign"></span>
          </div>
          <p class="tick2021">Tick all that apply.</p>
          <!-- prop="companytype" -->
          <el-form-item >
            <el-checkbox-group v-model="ruleForm.companytype">
              <el-checkbox label="Agriculture UAV/UAS" name="type"></el-checkbox>
              <br />
              <el-checkbox label="Fire Fighting UAV/UAS" name="companytype"></el-checkbox>
              <br />
              <el-checkbox label="Transporting Drones" name="companytype"></el-checkbox>
              <br />
              <el-checkbox label="Consumer Drones" name="companytype"></el-checkbox>
              <br />
              <el-checkbox label="Rescue Drones" name="companytype"></el-checkbox>
              <br />
              <el-checkbox label="UAV/UAS R&D" name="companytype"></el-checkbox>
              <br />
              <el-checkbox label="Other:" name="companytype"></el-checkbox>
              <br />
              <el-input
                class="elseinp"
                v-model="ruleForm.comtype_other"
                placeholder="Please fill in the 'Other' reason description"
              ></el-input>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <!-- <div class="tail">
          <el-form-item prop="position">
            <label>
              Job Title
              <span class="sign">*</span>
            </label>
            <el-input v-model="ruleForm.position" placeholder="Your answer"></el-input>
          </el-form-item>
        </div> -->

        <div class="tail">
          <div class="cause">Parallel Forums Selection (If applicable). Please note that there will be changes to the forums.</div>
         <p class="tick2021">Tick all that apply.</p>
          <el-form-item prop="forum">
            <el-checkbox-group v-model="ruleForm.forum">
              <el-checkbox
                label="International Conference of Precision Agricultural Aviation "
                name="forum"
              ></el-checkbox>
              <br />
              <el-checkbox
                label="Emergency and Safety Industry-education Integration Forum"
                name="forum"
              ></el-checkbox>
              <br />
              <el-checkbox label="Fire-fighting UAV Application Innovation Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="UAV Testing and Certification Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="Security UAV Summit Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox
                label="UAV System Standards Forum"
                name="forum"
              ></el-checkbox>
              <br />
              <el-checkbox label="UAV Surveying and Mapping Technology Application Summit Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="Anti-UAV Technology and Airport Security Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="Unmanned Systems Industrial Parks Development Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="China and Foreign UAV Chairman Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="International UAV/UAS Open Innovation Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="Low Altitude Industry and Service Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="International Conference on Air Traffic Regulations" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="Beidou Navigation Summit Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="WUAVF Council" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="UAS Designer Innovation Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="Logistics UAV Application Summit" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="Manned Drone Closed-door Meeting" name="forum"></el-checkbox>
              <br />

              <el-checkbox label="Inspection drone innovation conference" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="UAV Power Development Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="UAV Education and Training Development Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="Forum on UAV Application for Police, Inspection and Fighting" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="UAV New Material Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="Unmanned Water System Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="Autonomous Driving Innovation Application Technology Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="Unmanned Farm New Technology Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="UAV Flight Control Technology Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="UAV Smart Chip Technology Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="Unmanned System Science Education Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="EU Drone Market Entry Standards Sharing Conference" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="UAV Formation Technology Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="EU-China Unmanned Aerial System Technology Application Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="Intelligent Connected Vehicle Development Forum" name="forum"></el-checkbox>
              <br />
              
              <el-checkbox label="Other:" name="forum"></el-checkbox>
              <br />
              <el-input class="elseinp" v-model="ruleForm.forum_other" placeholder="Please fill in the 'Other' reason description"></el-input>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button class="subbin" type="primary" @click="submitForm('ruleForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      ruleForm: {
        name: '',
        Nationality: '',
        c_logo: '',
        phone: '',
        Company: '',
        companytype: [],
        comtype_other: '',
        position: '',
        com_phone: '',
        forum: [],
        forum_other: '',
      },
      rules: {
        name: [{required: true, message: 'This question must be filled out', trigger: 'blur' }],
        Nationality: [{required: true, message: 'This question must be filled out', trigger: 'blur' }],
        c_logo: [{ required: true, message: "此项必须填写", trigger: "blur" }],
        phone: [
          {required: true, message: 'This question must be filled out', trigger: 'blur' },
          { min: 11, message: 'Please enter the correct contact information', trigger: 'blur' }],
        Company: [{required: true, message: 'This question must be filled out', trigger: 'blur' }],
        
        com_phone: [
          {required: true, message: 'This question must be filled out', trigger: 'blur' },
          { min: 11, message: 'Please enter the correct contact information', trigger: 'blur' }],
        companytype: [
          {
            type: "array",
            required: true,
            message: "Choose at least one",
            trigger: "change"
          }
        ],
        position: [{required: true, message: 'This question must be filled out', trigger: 'blur' }],
        forum: [
          {
            type: "array",
            required: true,
            message: "至少选择一项",
            trigger: "change"
          }
        ],
      }
    };
  },
  beforeCreate() {
     
  },
   created(){
     
    //记录访问数量
     this.$axios({
      url:
        "http://en.droneworldcongress.com/form/index/speaker_noemail/index.html?button_id=" +
         this.$route.query.button_id +
        "&contacts_id=" +
        this.$route.query.contacts_id,
      method: "post",
      data: {}
    })
  },
  methods: {
    // 上传图片获取参数
    logo_success(res) {
      console.log(res);
      this.ruleForm.c_logo = res.url;
    },
    logo_before(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过10M!");
      }
    },
     handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid,object) => {
        if (valid) {
          let button_id = this.$route.query.button_id;
          let contacts_id = this.$route.query.contacts_id;
          // alert(this.ruleForm.Nationality);
          let permission = this.ruleForm.companytype.join(",");
          let forum = this.ruleForm.forum.join(",");
          let url = "http://en.droneworldcongress.com/form/index/speaker_noemail/index.html=" +button_id +"&contacts_id=" + contacts_id
          this.$axios({
            url:
              "http://en.droneworldcongress.com/form/index/speaker_noemail/index.html?button_id=" +
              button_id +
              "&contacts_id=" +
              contacts_id,
            method: "post",
            data: {
              name: this.ruleForm.name,
              nationality: this.ruleForm.Nationality,
              c_logo: this.ruleForm.c_logo,
              company: this.ruleForm.phone,
              contact_number: this.ruleForm.Company+this.ruleForm.comtype_other,
              company_focus: permission,
              job: this.ruleForm.position,
              c_contact_number: this.ruleForm.com_phone,
              attend_forums: forum+this.ruleForm.forum_other,
              url: url
            }
          })
            .then(res => {
              if(res.status == 0){
                this.$message({
                message: '提交失败',
                type: 'warning'
              });
              }{
                     this.$router.push({name:'succSpeaker'});
              }
              
            })
            .catch(err => {
              this.$message({
                message: '提交失败',
                type: 'warning'
              });
            });
        }else{
          setTimeout(()=>{
            var isError= document.getElementsByClassName("is-error");
            isError[0].querySelector('input').focus();
          },100);
          return false;
        
        }
      })
    },
  }
  
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.case {
  margin: auto;
  max-width: 90vw;
  width: 640px;
  padding-top: 12px;
}
.hello {
  width: 100%;
  height: 100%;
  background-color: rgb(240, 235, 248);
  background-size: 100% 100%;
}
.top {
  /* margin-top: 12px; */
  background-color: #fff;
  border: 1px solid #dadce0;
  border-radius: 8px;
  margin-bottom: 12px;
  padding: 24px;
  padding-top: 22px;
  position: relative;
  text-align: left;
}
.ti-blck {
  background-color: rgb(103, 58, 183);
  color: rgba(255, 255, 255, 1);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  height: 10px;
  left: -1px;
  position: absolute;
  top: -1px;
  width: calc(100% + 2px);
}
.title {
  font-family: "Google Sans", Roboto, Arial, sans-serif;
  font-size: 32px;
  font-weight: 400;
  line-height: 40px;
  color: #202124;
  line-height: 135%;
  max-width: 100%;
  min-width: 0%;
}
.introduce {
  font-family: Roboto, Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.2px;
  line-height: 20px;
  color: #202124;
  margin-top: 12px;
}
.must {
  font-family: Roboto, Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.2px;
  line-height: 20px;
  margin-top: 12px;
  color: #d93025;
}
.el-checkbox {
  white-space: pre-line !important;
  margin-right: 0px !important;
}
.el-checkbox__label {
  display: initial !important;
}

/* 尾部 */
.tail {
  -webkit-transition: background-color 200ms cubic-bezier(0, 0, 0.2, 1);
  transition: background-color 200ms cubic-bezier(0, 0, 0.2, 1);
  background-color: #fff;
  border: 1px solid #dadce0;
  border-radius: 8px;
  margin-bottom: 12px;
  padding: 24px;
  page-break-inside: avoid;
  word-wrap: break-word;
  text-align: left;
}
.cause {
  font-family: "Google Sans", Roboto, Arial, sans-serif;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.1px;
  line-height: 24px;
  color: #202124;
  font-weight: 400;
  width: 100%;
  word-break: break-word;
}
.form-inp {
  margin-left: 0px !important;
}
.sign {
  color: #d93025;
}
.inpdisp .el-input {
  display: none;
}
/* .elseinp {
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid #42b983;
} */
.subbin {
  background-color: rgb(103, 58, 183);
  margin-bottom: 20%;
}
.tick2021{
  color: #b7bfd0;
}


h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Speaker_noemail.vue